import { useEffect, useRef, useState } from "react";
import { Accordion } from "react-bootstrap";
import { AdminService } from "../../../../Services/Admin.service";

function loadScript(src, callback) {
    const baseUrl = process.env.REACT_APP_BASE_URL || "";  
    const script = document.createElement("script");
    // script.src = src;

    script.src = `${baseUrl}${src}`;
    script.onload = callback;
    document.body.appendChild(script);
}

function EmailFooter({ eventKey }) {
    const editorRef = useRef(null); // To hold the div reference for the editor
    const editorInstance = useRef(null); // To hold the editor instance
    const [footerMessage, setFooterMessage] = useState("");

    // Fetch email template list from AdminService
    function fetchAdminList() {
        const params = {
            type: "common",  // list | common  --- When common no need to pass type id
        };

        AdminService.getEmailTempletList(params)
            .then((response) => {
                if (response.success && response.data) {
                    const footerTemplate = response.data.list.find(item => item.identifier === "FOOTER");
                    if (footerTemplate) {
                        setFooterMessage(footerTemplate.message);
                    }
                }
            })
            .catch((error) => {
                console.error("Failed to fetch emailTemplate list", error);
            });
    }

    // Fetch the footer message on mount
    useEffect(() => {
        fetchAdminList();
    }, []); 
    
  const decodeHTML = (html) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
};
    // Initialize the rich text editor when the footerMessage changes
    // useEffect(() => {
    //     loadScript("/richtexteditor/rte.js", () => {
    //         loadScript("/richtexteditor/plugins/all_plugins.js", () => {
    //             if (window.RichTextEditor) {
    //                 // Initialize the editor instance
    //                 editorInstance.current = new window.RichTextEditor(editorRef.current);
    //                 const decodedMessage = decodeHTML(footerMessage);
    //                 editorInstance.current.setHTMLCode(decodedMessage);
                    
    //                 // Cleanup on component unmount or when footerMessage changes
    //                 return () => {
    //                     if (editorInstance.current) {
    //                         editorInstance.current.destroy();
    //                     }
    //                 };
    //             }
    //         });
    //     });
    // }, [footerMessage]);

    useEffect(() => {
        if (!footerMessage) return;

        let mounted = true;
        let retryTimer = null;

        const safeDestroy = () => {
            try {
            const inst = editorInstance.current;
            if (!inst) return;

            // If it's a wrapper object, try common teardown methods
            const tryFns = ['destroy', 'remove', 'dispose', 'unload', 'close', 'destroyEditor'];
            for (const fn of tryFns) {
                if (typeof inst[fn] === 'function') {
                inst[fn]();
                editorInstance.current = null;
                return;
                }
            }

            // If it's a DOM node, try removing it / clearing content
            if (inst instanceof HTMLElement) {
                inst.innerHTML = '';
                if (inst.parentNode) inst.parentNode.removeChild(inst);
                editorInstance.current = null;
                return;
            }

            // If it's something else, just null it (and log for debugging)
            console.warn('Unknown editor instance shape, cannot destroy gracefully:', inst);
            editorInstance.current = null;
            } catch (err) {
            console.error('Error while destroying editorInstance:', err);
            editorInstance.current = null;
            }
        };

        const initEditor = () => {
            if (!mounted) return;
            // if ref or library not ready, retry shortly
            if (!editorRef.current || typeof window.RichTextEditor !== 'function') {
            retryTimer = setTimeout(initEditor, 100);
            return;
            }

            // If an instance already exists, destroy it first
            if (editorInstance.current) {
            safeDestroy();
            }

            try {
            // create new instance
            const inst = new window.RichTextEditor(editorRef.current);

            // store instance and optionally log it so you can inspect available methods
            editorInstance.current = inst;
            // Helpful debug: uncomment to inspect shape in console
            // console.log('RTE instance:', inst);

            const decoded = decodeHTML(footerMessage);
            // try setHTMLCode if present, otherwise set innerHTML
            if (typeof inst.setHTMLCode === 'function') {
                inst.setHTMLCode(decoded);
            } else if (editorRef.current) {
                editorRef.current.innerHTML = decoded;
            }
            } catch (err) {
            console.error('Failed to initialize rich text editor:', err);
            }
        };

        // nested loader ensures rte.js and plugins load in sequence
        loadScript('/richtexteditor/rte.js', () => {
            loadScript('/richtexteditor/plugins/all_plugins.js', () => {
            initEditor();
            });
        });

        return () => {
            mounted = false;
            if (retryTimer) clearTimeout(retryTimer);
            safeDestroy();
        };
    }, [footerMessage]);


    // Get the content from the editor
    const getEditorContent = () => {
        return editorInstance.current?.getHTMLCode() || "";
    };

    // Handle the update of the email footer
    const handleUpdateEmailFooter = async () => {
        const params = {
            template_id: 2,
            title: "Footer",
            subject: null,
            message: getEditorContent(),
            from: null,
            bcc: null,
            replyto: null,
            type_id: 1,
        };

        try {
            let response;
            response = await AdminService.updateEmailTempletList(params);
            if (response.success) {
                
            } else {
                 
            }
        } catch (error) {
            console.error("Failed to update email footer", error);
        }
    };

    return (
        <Accordion.Item eventKey={eventKey}>
            <Accordion.Header>
                <div style={{ marginRight: '15px' }}>
                  <h3>Email Footer</h3>
                </div>
            </Accordion.Header>
            <Accordion.Body>
                <>
                    <p className="mt-3">Use this section to manage the email footer for all email templates</p>
                    <br />
                    <h4 className="mb-3"> Footer Text</h4> 
                    <div id="div_editor1" ref={editorRef}></div>
                    <button className="btn el-filled-btn mt-3" onClick={handleUpdateEmailFooter}>Save changes</button>
                </>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default EmailFooter;
